// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_NRX","cls2":"JJHomePageSearch-cls2_qLl JJHomePageSearch-cls1_NRX"};